export default __webpack_public_path__ + "static/media/google-play-badge 2.80c77058.png";